@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<div kb-layout="grid" [appEditorId]="editorIds?.mediums">
  @for (image of attributes.mediums; track image) {
    <ng-template #figureTemplate>
      <section kb-card [attr.kb-grid-item-columns]="attributes.mediums.length === 1 ? 12 : attributes.mediums.length === 2 ? 6 : 4" [appEditorId]="image.editorId">
        <kb-picture slot="picture" [appOgImage]="image.attributes" [picture]="imageToPicture(image.attributes, aspectRatio).sources" [alt]="image.attributes.alt"  [appEditorId]="image.editorIds?.src" [rootColumns]="4"></kb-picture>
        @if (image.attributes.caption) {
          <h3 slot="title" [appEditorId]="image.editorIds?.caption" kb-heading type="bar">
            <kb-line-clamp lines="2" force-min-lines [class.with-icon]="image.attributes.link">
              {{ image.attributes.caption }}
            </kb-line-clamp>
            @if (image.attributes.link) {
              <kb-icon [icon]="iconLink"></kb-icon>
            }
          </h3>
        }
      </section>
    </ng-template>
    @if (image.attributes.link) {
      <a
        [attr.kb-grid-item-columns]="attributes.mediums.length === 1 ? 12 : attributes.mediums.length === 2 ? 6 : 4"
        [kbRouterOrExternalLink]="image.attributes.link.attributes.url"
        [attr.target]="image.attributes.link.attributes.target"
        [appEditorId]="image.attributes.link.editorId"
      >
        <ng-container [ngTemplateOutlet]="figureTemplate"></ng-container>
      </a>
    } @else {
      <ng-container [ngTemplateOutlet]="figureTemplate"></ng-container>
    }
  }
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
